var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmarkCircleBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#01B1E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68023 22.3198C8.88926 21.5288 9.41388 19.8682 9.01128 18.8952C8.59394 17.8865 7.0625 17.0746 7.0625 16C7.0625 14.9253 8.59395 14.1135 9.01129 13.1048C9.41389 12.1318 8.88926 10.4712 9.68023 9.68023C10.4712 8.88926 12.1318 9.41388 13.1048 9.01128C14.1135 8.59394 14.9254 7.0625 16 7.0625C17.0747 7.0625 17.8865 8.59395 18.8952 9.01129C19.8682 9.41389 21.5288 8.88926 22.3198 9.68023C23.1107 10.4712 22.5861 12.1318 22.9887 13.1048C23.4061 14.1135 24.9375 14.9254 24.9375 16C24.9375 17.0747 23.4061 17.8865 22.9887 18.8952C22.5861 19.8682 23.1107 21.5288 22.3198 22.3198C21.5288 23.1107 19.8682 22.5861 18.8952 22.9887C17.8865 23.4061 17.0746 24.9375 16 24.9375C14.9253 24.9375 14.1135 23.4061 13.1048 22.9887C12.1318 22.5861 10.4712 23.1107 9.68023 22.3198Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 13.9375L14.7396 18.75L12.2188 16.3438",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleBlue);
export default __webpack_public_path__ + "static/media/checkmark_circle_blue.5b69161993d9c72d2ca8ec5ecf482df5.svg";
export { ForwardRef as ReactComponent };